import type { JSX } from 'react';

// Node twin of replacePlaceholdersWithBoldTags in ./translations.ts, for labels rendered as JSX.
export const replacePlaceholdersWithBoldNodes = (string: string): (string | JSX.Element)[] => {
  const regex = /\*(.*?)\*/g;
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;

  // Using let/const pattern to avoid assignment in while condition (ESLint no-cond-assign)
  let match = regex.exec(string);
  while (match !== null) {
    if (match.index > lastIndex) {
      parts.push(string.substring(lastIndex, match.index));
    }
    parts.push(<b key={`bold-${match.index}`}>{match[1]}</b>);

    lastIndex = regex.lastIndex;
    match = regex.exec(string);
  }

  if (lastIndex < string.length) {
    parts.push(string.substring(lastIndex));
  }

  return parts;
};

// Same pairing as the helper above, so the plain label and the emphasised one read alike.
export const removePlaceholders = (string: string): string => string.replace(/\*(.*?)\*/g, '$1'); // from *name* to name
